import type { FileWithContent } from "schemas/generated/file";

import React from "react";

import { SandpackLayout, SandpackProvider } from "@codesandbox/sandpack-react";

import { convertFilesToSandpackFiles } from "../utils/filesUtils";

function EditorSandpackProvider({
  files,
  productIds,
  openPages,
  displayMode,
  children,
  className = "flex !h-full !w-full flex-col",
  sandpackLayoutClassName = "flex h-full w-full flex-col",
}: {
  files: FileWithContent[];
  productIds: string[];
  openPages: string[];
  displayMode: "preview" | "edit";
  children: React.ReactNode;
  className?: string;
  sandpackLayoutClassName?: string;
}) {
  return (
    <SandpackProvider
      className={className}
      key={openPages.join(",")}
      options={{
        externalResources: ["https://cdn.tailwindcss.com"],
      }}
      customSetup={{
        dependencies: {
          "react-router-dom": "6.22.3",
          "@radix-ui/react-slot": "1.2.0",
          "@radix-ui/react-icons": "1.3.2",
          "class-variance-authority": "0.7.0",
          clsx: "2.0.0",
          "tailwind-merge": "3.2.0",
          "lucide-react": "0.344.0",
          "@radix-ui/react-accordion": "1.2.11",
          "@radix-ui/react-navigation-menu": "1.2.13",
          tailwindcss: "^4",
          "tw-animate-css": "^1.3.0",
          "@tailwindcss/postcss": "^4",
          uuid: "^9.0.0",
        },
        entry: "/src/index.tsx",
      }}
      files={convertFilesToSandpackFiles(
        files,
        productIds,
        openPages,
        displayMode,
      )}
      template="react-ts"
    >
      <SandpackLayout className={sandpackLayoutClassName}>
        {children}
      </SandpackLayout>
    </SandpackProvider>
  );
}

export default EditorSandpackProvider;
